import { getLinesFromPolygon as m } from "./index9.js";
import { doLinesIntersect as f } from "./index20.js";
import { isPointInside as a } from "./index19.js";
import { isVector3 as s } from "../three/index15.js";
function y(r, o) {
  let t, i;
  return s(r[0]) && s(r[1]) ? (t = r.map((e) => e.toArray()), i = o.map((e) => e.toArray())) : (t = r, i = o), t.every((e) => a(e, i)) ? !m(i).some((n) => f(n, t)) : !1;
}
export {
  y as isLineInside
};
//# sourceMappingURL=index18.js.map
